import AuthService from '../services/auth.service'

import Cookies from 'js-cookie'

const user = Cookies.getJSON('ow:user')
const initialState = user
  ? { status: { loggedIn: true }, user: user.data.user }
  : { status: { loggedIn: false }, user: null }

export const auth = {
  namespaced: true,

  state: initialState,

  actions: {
    async login ({ commit }, user) {
      try {
        const authResponse = await AuthService.login(user)
        if (authResponse.data) {
          commit('LOGIN_SUCCESS', authResponse.data.user)
        } else {
          commit('LOGIN_FAILURE')
        }
      } catch (error) {
        console.log(error)
      }
    },

    logout ({ commit }) {
      AuthService.logout()
      commit('LOGOUT')
    }
  },

  getters: {
    user (state) {
      return state.user
    },

    loggedIn (state) {
      return state.status.loggedIn
    }
  },

  mutations: {
    LOGIN_SUCCESS (state, user) {
      state.status.loggedIn = true
      state.user = user
    },

    LOGIN_FAILURE (state) {
      state.status.loggedIn = false
      state.user = null
    },

    LOGOUT (state) {
      state.status.loggedIn = false
      state.user = null
    }
  }
}
